module.exports = __webpack_public_path__ + "static/img/ttr01.2933c08.png";